export const siteInfo = {
  name: "Hillsborough Garden Club",
  tagline: "Member of The Garden Club of America",
  established: "Est. 1949",
  memberPortal: "http://members.hillsboroughgc.org",
  copyright: "Hillsborough Garden Club",
};

export const navSections = [
  { id: "home", label: "Home" },
  { id: "our-mission", label: "Our Mission" },
  { id: "philanthropy", label: "Philanthropy" },
  { id: "things-we-like", label: "Things We Like" },
  { id: "conservation", label: "Conservation" },
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Our Mission", href: "#our-mission" },
  { label: "Philanthropy", href: "#philanthropy" },
  { label: "Things We Like", href: "#things-we-like" },
  { label: "Conservation", href: "#conservation" },
];

export const linksMenu = [
  { label: "Our History", href: "#our-mission" },
  { label: "Garden Club of America", href: "#our-mission" },
  { label: "Philanthropy", href: "#philanthropy" },
  { label: "Conservation", href: "#conservation" },
  { label: "Creative Growth", href: "#things-we-like" },
  { label: "Bay Visions", href: "#conservation" },
];

export const missionText =
  "… to stimulate the knowledge and love of gardening, to share the advantages of association by means of educational meetings, conferences, correspondence, and publications, and to restore, improve, and protect the quality of the environment through educational programs and action in the fields of conservation and civic improvement.";

export const grantsLeft = [
  { label: "California Native Plant Society", href: "http://www.cnps.org/" },
  { label: "CuriOdyssey", href: "https://curiodyssey.org" },
  { label: "Filoli Internship Program", href: "https://filoli.org/" },
  { label: "Garden of Golden Gate Park — Youth in the Garden Program", href: "https://gggp.org" },
  { label: "Golden Gate National Parks Conservancy of California", href: "http://www.parksconservancy.org/" },
  { label: "Hillsborough Beautification Foundation's Harvest Garden", href: "https://www.hillsboroughbeautificationfoundation.org/harvestgarden" },
];

export const grantsRight = [
  { label: "Peninsula Open Space Trust — San Gregorio Ranch", href: "http://www.openspacetrust.org/" },
  { label: "Project Wingspan Golden Gate", href: "https://www.pollinator.org/wingspan" },
  { label: "Pollinator Partnership (P2P)", href: "https://www.pollinator.org" },
  { label: "Save the Bay", href: "https://savesfbay.org" },
  { label: "Save the Redwoods League", href: "https://www.savetheredwoods.org/" },
  { label: "San Mateo County Parks Foundation", href: "https://www.smcgov.org/parks/san-mateo-county-parks-foundation" },
];

export const philanthropyParagraphs = [
  "The Hillsborough Garden Club is committed to supporting the communities of San Mateo County through contributions to various environmental organizations, public gardens, schools, parks and museums.",
  "Club members have been actively involved with projects such as the Marilyn Hills Memorial Garden that graces the front of Crocker Middle School in Hillsborough; hands-on invasive species eradication at local natural land preserves; planting and maintenance of the traffic island at Hayne Road, a primary entrance into Hillsborough; and planting gardens at Alcatraz, Coyote Point's Wildlife Center, Hillsborough's Town Hall and San Mateo's Arboretum.",
  "The club participated in the Garden Club of America's 2013 Centennial Tree project by planting 28 oak trees at Coyote Point, the peninsula's most visited park. Several times a year the members create seasonal baskets to cheer up residents in local care facilities.",
];

export const flowerFlashImages = [
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1714941211955-C5V5FJ9D8W61IP2FWIIL/IMG_5176.jpeg?format=750w",
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1714941209316-EUTHQ915YHZEP6MCKZN7/IMG_5182.jpeg?format=750w",
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1714941214072-3ECYS2HYNCKE4VV3HTHX/FullSizeRender.jpeg?format=750w",
];

export const dahliaImages = [
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1661225415690-RCE9MWEDK4SM6OUI8GHH/Dahlia+2.jpg?format=500w",
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1661225439585-JRSSMW66QZDWBSV8POH5/Dahlia+1.jpg?format=500w",
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1661225454498-L20LAGSP5ETYHFWWSZQ4/Dahlia+3.jpg?format=500w",
  "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1661225491165-5C5QPU0MQTDK5SDFCTYT/Dahlia+4.jpg?format=500w",
];

export type Feature = {
  title: string;
  body: string;
  href?: string;
  hrefLabel?: string;
  image?: string;
  imageAlt?: string;
  layout?: "image-right" | "image-left" | "image-full" | "text-only";
};

export const thingsWeLike: Feature[] = [
  {
    title: "Cultivated by Christin",
    body: "Christin Geall brings together her love for teaching, art, philosophy and plants in her book Cultivated: The Elements of Floral Style.",
    href: "https://www.cultivatedbychristin.com/book",
    hrefLabel: "Explore the book",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/9f3d5e85-5d23-4bc9-bf6d-894dc5122269/Screen+Shot+2022-03-10+at+4.03.24+PM.png?format=1000w",
    imageAlt: "Cultivated by Christin floral design",
    layout: "image-right",
  },
  {
    title: "La Follia Design by Thierry Chantrel",
    body: "Well known throughout Europe and America for his artistry and attention to detail, Thierry Chantrel's love for flowers and beauty is reflected in his creations both small and grand.",
    href: "https://www.thierrychantrel.com",
    hrefLabel: "Visit Thierry Chantrel",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/2e901e44-5afb-4c04-8dee-c2742a98b730/Screen+Shot+2022-03-10+at+3.53.38+PM.png?format=1000w",
    imageAlt: "La Follia floral design",
    layout: "image-left",
  },
  {
    title: "Françoise Weeks Floral",
    body: "Françoise Weeks is a Belgian-born florist based in Portland, Oregon who combines her European reverence for flowers and nature with a mechanical ingenuity in a unique style of Textural Woodlands and Botanical Haute Couture pieces.",
    href: "https://francoiseweeks.com/francoise-weeks/",
    hrefLabel: "Visit Françoise Weeks",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/73206fc5-3105-4767-9c6b-c49aaa1fff69/Screen+Shot+2022-03-10+at+3.41.00+PM.png?format=1000w",
    imageAlt: "Françoise Weeks floral design",
    layout: "image-right",
  },
  {
    title: "Natalie Bowen Designs",
    body: "A boutique floral and event design studio specializing in breathtakingly beautiful arrangements with a chic creative edge. Design style is inspired by color, movement, architecture and fresh seasonal flowers.",
    href: "http://nataliebowendesigns.com",
    hrefLabel: "Visit Natalie Bowen Designs",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1632084598289-YQHRO0BC452K1N767BKU/bowen.jpg?format=1000w",
    imageAlt: "Natalie Bowen Designs floral arrangement",
    layout: "image-left",
  },
  {
    title: "Save the Redwoods League",
    body: "Nestled in the wooded hills along the Sonoma coast lies a hidden wonder that has remained largely untouched for thousands of years — 730 acres of pristine forest known as Harold Richardson Redwoods Reserve. These are the tallest and biggest ancient redwoods on private lands in Sonoma County.",
    href: "https://www.savetheredwoods.org/project/harold-richardson-redwoods-reserve/",
    hrefLabel: "Read about the reserve",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1540232038782-FN4G8K1QRP18RX3N8JTQ/redwoods.jpeg?format=1000w",
    imageAlt: "Ancient redwoods",
    layout: "image-right",
  },
  {
    title: "San Francisco Flower Mart",
    body: "At 6th & Brannan, SFFM is one of only five grower-owned wholesale flower markets in the U.S. — over 50 individual vendors.",
    href: "https://www.sanfranciscoflowermart.com",
    hrefLabel: "Visit SFFM",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1533937525242-8I6S6KJGY5UFUQ70RD3W/sffm.jpeg?format=1000w",
    imageAlt: "San Francisco Flower Mart",
    layout: "image-left",
  },
  {
    title: "Max Gill Designs",
    body: "\"My work is always botanically inspired. What I find most compelling in nature is when plants are struggling to find their place in the environment. As they fight to overcome the challenges of space and light, often surprising us with their juxtaposition, they create beauty through adaptation.\"",
    href: "http://www.maxgilldesign.com",
    hrefLabel: "Visit Max Gill Designs",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1521937136613-EWVG2N9DD68KV5V5HJWR/maxg.jpeg?format=1000w",
    imageAlt: "Max Gill botanical design",
    layout: "image-right",
  },
  {
    title: "Ken Fulk Designs",
    body: "Ken Fulk is a designer of experiences big and small, renowned for his layered interiors and over-the-top parties. Notable projects include The Battery and Leo's Oyster Bar in San Francisco, and Sadelle's in New York.",
    href: "http://kenfulk.com/",
    hrefLabel: "Check out Ken Fulk",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1519183497309-TEL32GHV3VXQNCR0QSO6/fulkbook.jpg?format=1000w",
    imageAlt: "Ken Fulk book",
    layout: "image-left",
  },
  {
    title: "C-Change Conversations",
    body: "A volunteer-led association committed to promoting non-partisan dialogue and education around the topic of climate change, engaging our community in critical discussions about its implications for us and for our children.",
    href: "https://www.c-changeconversations.org/",
    hrefLabel: "Learn about C-Change",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1517188783293-H9SGFLRI5TCTUQY5D9E6/giga-khurtsilava-354812.jpg?format=1000w",
    imageAlt: "Climate conversation",
    layout: "image-right",
  },
  {
    title: "joSon, Artist and Photographer",
    body: "\"Fotanicals: The Secret Language of Flowers\" was an exhibition of photographs by San Francisco artist joSon. Large, vivid, minimalist portraits of flowers, each flower photographed singularly on black or white backgrounds.",
    href: "https://www.josonstudio.com/",
    hrefLabel: "Explore joSon's website",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1508626903915-P31A9ATRFIYKA2VPPVXT/joson.jpg?format=1000w",
    imageAlt: "joSon floral photography",
    layout: "image-left",
  },
  {
    title: "Cornerstone Sonoma — Sunset Gardens & Marketplace",
    body: "A wine country marketplace featuring world-class shopping, boutique wineries and tasting rooms, artisanal foods, art-inspired gardens, live music, and home to Sunset's Gardens + Outdoor Test Kitchen.",
    href: "https://www.cornerstonesonoma.com",
    hrefLabel: "Visit Cornerstone Sonoma",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1499312090922-SVGI3B1CP5PS2H9XRXIM/image-asset.jpeg?format=1000w",
    imageAlt: "Cornerstone Sonoma gardens",
    layout: "image-right",
  },
  {
    title: "John James Designs",
    body: "Noted San Francisco designer John James shares inspiration with our members through workshops and talks on floral artistry.",
    href: "http://johnjamesdesigns.com/",
    hrefLabel: "Find more about John",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1457911336080-23FSYOIYEKO6KLYHDWTD/image-asset.jpeg?format=1000w",
    imageAlt: "John James Designs",
    layout: "image-left",
  },
  {
    title: "Studio Choo",
    body: "A floral design studio/showroom in San Francisco — visit their website for design inspiration, workshops, and more.",
    href: "http://studiochoo.com/",
    hrefLabel: "Visit Studio Choo",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1474914269954-S7VTT6TYMSIW146BQELN/image-asset.jpeg?format=1000w",
    imageAlt: "Studio Choo floral design",
    layout: "image-right",
  },
  {
    title: "Creative Growth Art Center in Oakland",
    body: "The New York Times explores the magic happening at this artist studio — HGC was proud to have partnered with Creative Growth for our 2015 flower show.",
    href: "http://creativegrowth.org/",
    hrefLabel: "Visit Creative Growth",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1450457417043-AP2ET79DVWFYFQR4QWYA/image-asset.jpeg?format=1000w",
    imageAlt: "Creative Growth Art Center",
    layout: "image-left",
  },
];

export type ConservationCard = {
  title: string;
  body: string;
  href: string;
  hrefLabel: string;
  image: string;
  imageAlt: string;
};

export const conservationCards: ConservationCard[] = [
  {
    title: "Bay Visions",
    body: "In the spirit of fostering collaboration and camaraderie among the six Northern California GCA clubs, the Bay Visions Committee works to restore and protect the San Francisco Bay.",
    href: "https://www.gcamerica.org/",
    hrefLabel: "Learn about Bay Visions",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1440630288356-NK9OG8ETSFXG4GDZ1E6S/image-asset.jpeg?format=1000w",
    imageAlt: "San Francisco Bay",
  },
  {
    title: "Partners for Plants",
    body: "An initiative of the Conservation and Horticulture Committees in the GCA — partnering with public land agencies, protecting rare plants, restoring habitat, and increasing biodiversity.",
    href: "https://www.gcamerica.org/partners-for-plants",
    hrefLabel: "Learn about Partners for Plants",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1440630354548-L20ALX4IO0AX1CZYZN5Y/image-asset.jpeg?format=1000w",
    imageAlt: "Native plants",
  },
  {
    title: "CuriOdyssey",
    body: "Named one of the seven best Science Museums for children in the U.S., CuriOdyssey brings science and wildlife together for curious young minds.",
    href: "http://www.curiodyssey.org/",
    hrefLabel: "Visit CuriOdyssey",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1445319623305-FJI4EF2XRL33IW2KD77R/image-asset.jpeg?format=1000w",
    imageAlt: "CuriOdyssey science museum",
  },
  {
    title: "Filoli",
    body: "A historic house and garden in Woodside, California — see what's happening this season and discover one of the finest remaining country estates of the early 20th century.",
    href: "https://filoli.org/",
    hrefLabel: "See what's happening",
    image: "https://images.squarespace-cdn.com/content/v1/55db92c4e4b035628e290c2f/1516413007490-6PDTC8RR5PMNSJ7L6NSO/filoli.jpg?format=1000w",
    imageAlt: "Filoli gardens",
  },
];

export const conservationIntro = [
  "From the time of its founding, the Garden Club of America has been an active force in the promotion of environmental awareness and the preservation of natural resources. In 1921, one of the four founding GCA members testified before Congress on behalf of the parks of Washington, DC.",
  "In June 1969, the National Affairs and Legislation Committee (NAL) was established as a separate entity from the Conservation Committee. The NAL and Conservation Committees work in tandem to enhance the GCA mission to restore, improve, and protect the quality of the environment through educational programs and action in the fields of conservation and civic improvement.",
  "Committee zone members carry the work of both committees to the clubs in their zones, publishing Conservation Watch, a quarterly online newsletter featuring conservation and environmental news from around the country.",
];